import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';
import LegalInfoModal from '../components/Common/LegalInfoModal';
import { LegalSection } from '../data/legalPages';

type LegalModalContextValue = {
  openLegal: (section: LegalSection) => void;
};

const LegalModalContext = createContext<LegalModalContextValue | null>(null);

export const LegalModalProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [section, setSection] = useState<LegalSection | null>(null);
  const openLegal = useCallback((s: LegalSection) => {
    setSection(s);
  }, []);
  const closeLegal = useCallback(() => setSection(null), []);

  const value = useMemo(() => ({ openLegal }), [openLegal]);

  return (
    <LegalModalContext.Provider value={value}>
      {children}
      <LegalInfoModal
        open={section !== null}
        section={section ?? 'about'}
        onClose={closeLegal}
      />
    </LegalModalContext.Provider>
  );
};

export function useLegalModal(): LegalModalContextValue {
  const ctx = useContext(LegalModalContext);
  if (!ctx) {
    throw new Error('useLegalModal yalnızca LegalModalProvider içinde kullanılmalıdır');
  }
  return ctx;
}
